// SEO utility functions for generating structured data

export const generateWebsiteStructuredData = (siteUrl = 'https://3afer.net') => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "3afer",
  "alternateName": "ثافر",
  "url": siteUrl,
  "description": "منصة عافر التعليمية",
  "inLanguage": "ar",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${siteUrl}/search?q={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
})

export const generateOrganizationStructuredData = (siteUrl = 'https://3afer.net') => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "3afer",
  "alternateName": "ثافر",
  "url": siteUrl,
  "logo": `${siteUrl}/logo.png`,
  "description": "منصة عافر التعليمية",
  "sameAs": [
    // Add your social media links here
    // "https://www.facebook.com/3afer",
    // "https://www.twitter.com/3afer",
    // "https://www.instagram.com/3afer"
  ]
})

export const generateCourseStructuredData = (course, siteUrl = 'https://3afer.net') => {
  if (!course) return null

  const courseUrl = `${siteUrl}/courses/${course.id}`
  const image = course.thumbnail 
    ? (course.thumbnail.startsWith('http') ? course.thumbnail : `${siteUrl}${course.thumbnail}`)
    : `${siteUrl}/logo.png`

  return {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": course.title,
    "description": course.description || course.title,
    "image": image,
    "url": courseUrl,
    "provider": {
      "@type": "Organization",
      "name": "3afer",
      "url": siteUrl
    },
    "inLanguage": "ar",
    "courseCode": course.id?.toString(),
    "educationalLevel": course.level || "Beginner",
    "timeRequired": course.duration ? `PT${course.duration}M` : undefined,
    "numberOfCredits": course.credits || undefined,
    "aggregateRating": course.rating ? {
      "@type": "AggregateRating",
      "ratingValue": course.rating,
      "ratingCount": course.reviews_count || 0
    } : undefined,
    "offers": course.price ? {
      "@type": "Offer",
      "price": course.price,
      "priceCurrency": "EGP",
      "availability": "https://schema.org/InStock"
    } : undefined
  }
}

export const generateBreadcrumbStructuredData = (items, siteUrl = 'https://3afer.net') => {
  if (!items || items.length === 0) return null

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url ? `${siteUrl}${item.url}` : undefined
    }))
  }
}

export const generateArticleStructuredData = (article, siteUrl = 'https://3afer.net') => {
  if (!article) return null

  const articleUrl = `${siteUrl}/community/posts/${article.id}`
  const image = article.image 
    ? (article.image.startsWith('http') ? article.image : `${siteUrl}${article.image}`)
    : `${siteUrl}/logo.png`

  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.content?.substring(0, 200) || article.title,
    "image": image,
    "url": articleUrl,
    "datePublished": article.created_at,
    "dateModified": article.updated_at || article.created_at,
    "author": {
      "@type": "Person",
      "name": article.user?.name || "مستخدم 3afer"
    },
    "publisher": {
      "@type": "Organization",
      "name": "3afer",
      "logo": {
        "@type": "ImageObject",
        "url": `${siteUrl}/logo.png`
      }
    },
    "inLanguage": "ar"
  }
}

export const generateVideoStructuredData = (video, course, siteUrl = 'https://3afer.net') => {
  if (!video || !course) return null

  const videoUrl = `${siteUrl}/courses/${course.id}/lectures/${video.id}`
  const thumbnail = video.thumbnail 
    ? (video.thumbnail.startsWith('http') ? video.thumbnail : `${siteUrl}${video.thumbnail}`)
    : `${siteUrl}/logo.png`

  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": video.title,
    "description": video.description || video.title,
    "thumbnailUrl": thumbnail,
    "uploadDate": video.created_at,
    "contentUrl": video.url,
    "embedUrl": videoUrl,
    "duration": video.duration ? `PT${video.duration}S` : undefined,
    "inLanguage": "ar",
    "isPartOf": {
      "@type": "Course",
      "name": course.title,
      "url": `${siteUrl}/courses/${course.id}`
    }
  }
}
